import { createContext, useState } from 'react';

export const GestionMaterialContext = createContext();

export const GestionMaterialProvider = ({ children }) => {
  const [inputValueSearch, setInputValueSearch] = useState(null);
  const [inputAfter, setInputAfter] = useState('');

  const data = {
    inputValueSearch,
    setInputValueSearch,
    inputAfter,
    setInputAfter,
  };

  return <GestionMaterialContext.Provider value={data}>{children}</GestionMaterialContext.Provider>;
};
